import Vue from 'vue'
import Vuex from 'vuex'
import makeStore from './store'
import { expandableBoxesHandler, initStateData } from './utils'
import App from './App.vue'

export const store = makeStore()

import router from './router'

Vue.config.productionTip = false

Vue.use(Vuex)

new Vue({
  store,
  router,
  render: h => h(App),
  created() {
    this.$store.dispatch({
      type: 'initState',
      payload: Object.assign(initStateData)
    })
    expandableBoxesHandler()
  }
}).$mount('#app')
